import React from 'react';
import './MembershipSummary.css';

const ArrowLeftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#999"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="arrow-left-icon"
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const PremiumIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <circle cx="17" cy="17" r="16" fill="#F6B800"/>
    <circle cx="17" cy="17" r="12" fill="white"/>
    <circle cx="17" cy="17" r="9" fill="#F6B800"/>
    <polygon points="17,12.5 20,17 17,21.5 14,17" fill="white"/>
  </svg>
);

const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#999"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="info-icon"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

const MembershipSummary = () => {
  return (
    <div className="membership-summary">
      <a href="/" className="go-back-link">
        <ArrowLeftIcon />
        Go back
      </a>

      <div className="subscribe-to-text">Subscribe to:</div>

      <div className="premium-box">
        <div className="premium-icon">
          <PremiumIcon />
        </div>
        <div>
          <div className="premium-title">Premium Membership</div>
          <div className="premium-desc">Full access to all sections and functionalities.</div>
        </div>
      </div>

      <div className="price-monthly">$11.00AUD/month</div>

      <div className="billing-summary">
        <div className="row">
          <span className="label-bold">Premium membership</span>
          <span className="value-bold">$11.00AUD</span>
        </div>
        <div className="billed-monthly">Billed monthly</div>

        <hr className="divider" />

        <div className="row">
          <span className="label">Subtotal</span>
          <span className="value-subtle">$11.00AUD</span>
        </div>

        {/* <button className="promo-code-btn" type="button">
          Add promotion code
        </button> */}

        <div className="row tax-row">
          <span className="label">
            Tax <InfoIcon />
          </span>
          <span className="value-subtle">$0.00</span>
        </div>

        <hr className="divider" />

        <div className="row total-row">
          <span className="label-bold">Total due today</span>
          <span className="value-bold">$11.00AUD</span>
        </div>
      </div>
    </div>
  );
};

export default MembershipSummary;
